import { render, staticRenderFns } from "./BulkSchema.vue?vue&type=template&id=5687c8ec&scoped=true"
import script from "./BulkSchema.vue?vue&type=script&lang=ts"
export * from "./BulkSchema.vue?vue&type=script&lang=ts"
import style0 from "./BulkSchema.vue?vue&type=style&index=0&id=5687c8ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5687c8ec",
  null
  
)

export default component.exports